import axios from "axios";
import server_config from '../ServerConfiguration';

const fevir_node_server_address = server_config["fevir_node_server_address"];

const getUserImportanceRatingDictionary = async (apiToken = null) => {
    if (!apiToken) {
        console.log("no apiToken");
        return null;
    }
    console.log("CALLING SERVER with getuserimportanceratingdictionary")
    return await axios({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 120000,
        data: {
            'functionid': 'getuserimportanceratingdictionary',
            'apiToken': apiToken
        },
    }).then((resp) => {
        if (resp?.data) {
            console.log(resp.data)
            return resp.data;
            //resp.data includes { "success": true,
            //  "userImportanceRatingDictionary": userImportanceRatingDictionary }
            // where userImportanceRatingDictionary uses foi as key (foi is for EvidenceVariable) and object with
            //    {
            //        "desirable": boolean/null, 
            //        "relativeimportance": number/NaN
            //    }
        }
        console.log("NO RESPONSE from getuserimportanceratingdictionary call");
    }).catch((error) => { console.log(error); });
};

const addUserImportanceRatingToDatabase = async (item, apiToken) => {
    if (!apiToken) {
        console.log("no apiToken");
        return null;
    }
    if (!item) {
        console.log("no item");
        return null;
    }
    /** item is an object
     * {
            id: targetfoi,
            exists: true,
            desirability: boolean or null,
            percentageValue: number or NaN,
            itemChanged: true
        }
     */
    console.log("CALLING SERVER with adduserimportanceratingtodatabase");
    return await axios({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 120000,
        data: {
            'functionid': 'adduserimportanceratingtodatabase',
            'apiToken': apiToken,
            'item': item
        },
    }).then((resp) => {
        if (resp?.data) {
            if (resp.data.success) {
                console.log(resp.data)
                return resp.data;
            } else {
                console.log("UNSUCCESSFUL RESPONSE from adduserimportanceratingtodatabase call");
                return resp.data;
            }
        } else {
            console.log("NO RESPONSE from adduserimportanceratingtodatabase call");
        }
    }).catch((error) => { console.log(error); });
};

const updateUserImportanceRatingInDatabase = async (item, apiToken) => {
    if (!apiToken) {
        console.log("no apiToken");
        return null;
    }
    if (!item) {
        console.log("no item");
        return null;
    }
    /** item is an object
     * {
            id: targetfoi,
            exists: true,
            desirability: boolean or null,
            percentageValue: number or NaN,
            itemChanged: true
        }
     */
    console.log("CALLING SERVER with updateuserimportanceratingindatabase");
    return await axios({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 120000,
        data: {
            'functionid': 'updateuserimportanceratingindatabase',
            'apiToken': apiToken,
            'item': item
        },
    }).then((resp) => {
        if (resp?.data) {
            if (resp.data.success) {
                return resp.data;
            } else {
                console.log("UNSUCCESSFUL RESPONSE from updateuserimportanceratingindatabase call");
                return resp.data;
            }
        } else {
            console.log("NO RESPONSE from updateuserimportanceratingindatabase call");
        }
    }).catch((error) => { console.log(error); });
};

export default getUserImportanceRatingDictionary;
export { addUserImportanceRatingToDatabase, updateUserImportanceRatingInDatabase }